<template>
  <div class="admin-settings">
    <v-btn class="mb-3" @click="open" block color="primary">Redirection Settings (custom STC)</v-btn>
    <v-dialog fullscreen v-model="openModal">
      <v-card class="d-flex flex-column">
        <v-toolbar class="flex-grow-0" dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Admin Settings (ADMIN ONLY)</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="loading" text @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="flex-grow-1 pa-5">
          <div class="label font-weight-bold">
            Global
          </div>
          <div class="section">
            <v-text-field v-model="redirect" label="Redirect URL"></v-text-field>
            <v-text-field v-model="preview" label="Preview URL"></v-text-field>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'AdminSettings',
  computed: mapGetters(['stcConfig', 'previewUrl', 'redirectUrl']),
  data () {
    return {
      openModal: false,
      loading: false,
      preview: '',
      redirect: ''
    }
  },
  methods: {

    open () {
      this.preview = this.previewUrl
      this.redirect = this.redirectUrl
      this.openModal = true
    },

    close () {
      this.openModal = false
    },

    save () {
      this.loading = true
      this.openModal = false
      this.loading = false
      this.$store.dispatch('updateAdminSettings', { redirectUrl: this.redirect, previewUrl: this.preview }).then(() => {
        this.openModal = false
        this.loading = false
      })
    }
  }
}

</script>

<style lang="sass" scoped>

.fullscreen
  height: 100%

</style>
